import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../config";

export const userCoreApi = createApi({
  reducerPath: "userCoreApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_API,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("o1HybridUser");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    userLogin: builder.mutation({
      query: (payload) => ({
        url: "/user/smartlearn/login",
        method: "POST",
        body: { ...payload },
      }),
    }),
    userResetPasswordOtp: builder.mutation({
      query: (payload) => ({
        url: "/user/smartlearn/reset-password-otp",
        method: "POST",
        body: { ...payload },
      }),
    }),
    userResetPassword: builder.mutation({
      query: (payload) => ({
        url: "/user/smartlearn/reset-password",
        method: "POST",
        body: { ...payload },
      }),
    }),
    userDetails: builder.query({ query: () => "/user/smartlearn/" }),
    subjectContent: builder.query({
      query: (subject) => `/smartlearn/content/${subject}`,
    }),
    s3PresignedUrl: builder.query({
      query: (params) =>
        `/smartlearn/content/${params.subject}/key/${params.s3Key}` +
        (params?.extension ? `?extension=${params.extension}` : ""),
    }),
    submitQuiz: builder.mutation({
      query: (params) => ({
        url: `smartlearn/quiz/${params.subject}`,
        method: "POST",
        body: params.payload,
      }),
    }),
  }),
});

export const {
  useUserLoginMutation,
  useUserResetPasswordOtpMutation,
  useUserResetPasswordMutation,
  useUserDetailsQuery,
  useSubjectContentQuery,
  useS3PresignedUrlQuery,
  useSubmitQuizMutation,
} = userCoreApi;
